import styled from "styled-components";
import { theme } from "../../styles/theme";

export const Container = styled.div`
    width: 100%;
    box-sizing: border-box;
    background-color: ${theme.colors.gray.Cinza_13};
    border-radius: 10px;
    padding: 24px;
`;

export const Title = styled.h2`
    margin: 0 0 20px 0;
    font-family: Lato;
    font-size: 18px;
    font-weight: 700;
    color: ${theme.colors.gray.Cinza_1};
`;

export const Cols = styled.div`
    display: flex;
    gap: 16px;

    @media only screen and (max-width: 900px) {
        flex-direction: column;
    }
`;

export const Col = styled.div`
    flex: 1;
`;

export const ColLabel = styled.h5`
    margin: 0 0 12px 0;
    font-family: Lato;
    font-size: 11px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.4px;
    color: ${theme.colors.gray.Cinza_7};
`;

export const Item = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px 0;
    border-bottom: 1px solid ${theme.colors.gray.Cinza_11};

    &:last-child {
        border-bottom: none;
    }
`;

export const ItemInfo = styled.div``;

export const ItemName = styled.p`
    margin: 0;
    font-family: Lato;
    font-size: 13px;
    font-weight: 700;
    color: ${theme.colors.gray.Cinza_1};
`;

export const ItemSubtitle = styled.p`
    margin: 2px 0 0 0;
    font-family: Lato;
    font-size: 11px;
    color: ${theme.colors.gray.Cinza_7};
`;

export const ItemValue = styled.span`
    font-family: Lato;
    font-size: 13px;
    font-weight: 700;
    color: ${theme.colors.green.Verde_AgroReceita};
    white-space: nowrap;
`;

export const LoadingBox = styled.div`
    width: 100%;
    min-height: 140px;
    display: flex;
    align-items: center;
    justify-content: center;
`;
